<script>
    import BarItem from './BarItem.svelte';
    export let value;
    export let choices;
</script>

{#each choices as choice}
    <BarItem active={value === choice[0]}>{choice[1]}</BarItem>
{/each}
